// ChallanPage.js

import React, { useState } from "react";
import "../components/Styles/ChallanPage.css";

import {
  FaSearch,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaChevronDown,
} from "react-icons/fa";

function ChallanPage() {

  /* ================= CHATBOT ================= */

  const [message, setMessage] = useState("");
  const [reply, setReply] = useState("");

  const handleSend = () => {

    if (message.trim() === "") return;

    if (message.toLowerCase().includes("payment")) {

      setReply(
        "Our support team will help you with challan payment issues."
      );

    }

    else if (message.toLowerCase().includes("challan")) {

      setReply(
        "Please enter your vehicle number to check challan details."
      );

    }

    else if (message.toLowerCase().includes("fine")) {

      setReply(
        "You can pay your pending fine securely online."
      );

    }

    else {

      setReply(
        "Thank you for contacting us. Our support team will reply shortly."
      );

    }

    setMessage("");

  };

  return (

    <div className="challan-page">

      {/* HERO */}

      <section className="challan-hero">

        <div className="hero-overlay"></div>

        <div className="container">

          <div className="hero-top-tag">
            Traffic Challan Search
          </div>

          <h1>
            Check Traffic <span>Challans</span>
          </h1>

          <p>
            Enter your vehicle number to check pending traffic challans
            and pay them instantly with secure payment options.
          </p>

          <div className="search-box">

            <div className="country-code">
              <span>IND</span>
            </div>

            <input
              type="text"
              placeholder="RJ 14 CD 2345"
            />

            <button>
              <FaSearch />
            </button>

          </div>

        </div>

      </section>

      {/* WHY CHOOSE */}

      <section className="challan-why-section">

  <div className="container">

    <div className="challan-why-title">

      <h2>Why Choose Our Challan Service?</h2>

      <p>
        Experience the most reliable and efficient challan
        management system with advanced features and 24/7 support.
      </p>

    </div>

          <div className="challan-why-grid">

            {/* CARD 1 */}

            <div className="challan-why-card">

              <span>Instant challan search</span>

              <h3>
                Advanced search system, instantly locate all your challans.
              </h3>

              <img
                src="https://images.unsplash.com/photo-1502877338535-766e1452684a?q=80&w=1200&auto=format&fit=crop"
                alt=""
              />

            </div>

            {/* CARD 2 */}

            <div className="challan-why-card">

              <span>Email and web support</span>

              <h3>
                Reach out via email for any assistance you need.
              </h3>

              <div className="chat-ui">

                <div className="chat-left">
                  Hey I'm having trouble with my challan payment.
                </div>

                {reply && (

                  <div className="chat-right">
                    {reply}
                  </div>

                )}

                <div className="chat-input-box">

                  <input
                    type="text"
                    placeholder="Type your message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />

                  <button onClick={handleSend}>
                    Send
                  </button>

                </div>

              </div>

            </div>

          </div>

          <div className="uptime-box">

            <h1>99.99% Uptime</h1>

          </div>

        </div>

      </section>


      {/* WHAT IS E CHALLAN */}

<section className="echallan-section">

  <div className="container">

    <div className="section-title">

      <h2>
        What is an <span>E-Challan?</span>
      </h2>

      <p>
        An E-Challan is a digital traffic fine issued by Indian traffic
        authorities for road rule violations, replacing traditional paper challans.
      </p>

    </div>

    <div className="echallan-grid">

      {/* LEFT CARD */}

      <div className="challan-ticket">

        <div className="ticket-left">

          <div className="ticket-top">

            <div>
              <span className="ticket-label">
                TRAFFIC E-CHALLAN
              </span>

              <h4>#MH-2026-789456</h4>
            </div>

            <div className="ticket-status">
              UNPAID
            </div>

          </div>

          <div className="vehicle-box">

            <p>VEHICLE</p>

            <h2>MH 12 AB 1234</h2>

          </div>

          <div className="violation-box">

            <span>VIOLATION</span>

            <h3>Signal Jump / Red Light Violation</h3>

          </div>

          <div className="ticket-info">

            <div>
              <span>DATE</span>
              <p>08 Feb 2026</p>
            </div>

            <div>
              <span>TIME</span>
              <p>14:32 IST</p>
            </div>

          </div>

          <div className="location-box">

            <span>LOCATION</span>

            <p>MG Road Signal, Pune</p>

          </div>

          <div className="ticket-bottom">

            <div>
              <span>FINE AMOUNT</span>
              <h2>₹ 500</h2>
            </div>

            <div>
              <span>DUE DATE</span>
              <h3>09 Apr 2026</h3>
            </div>

          </div>

        </div>

        <div className="ticket-right">

          <div className="barcode"></div>

          <h2>PAY NOW</h2>

        </div>

      </div>

      {/* RIGHT FEATURES */}

      <div className="echallan-right">

        <div className="feature-box">
          <h3>Captured Digitally</h3>
          <p>
            Traffic violations are recorded by CCTV cameras and devices.
          </p>
        </div>

        <div className="feature-box">
          <h3>Linked to Vehicle</h3>
          <p>
            E-Challans are linked to your vehicle registration number.
          </p>
        </div>

        <div className="feature-box">
          <h3>Instant Notification</h3>
          <p>
            You receive SMS alerts when a challan is issued.
          </p>
        </div>

        <div className="feature-box">
          <h3>60-Day Window</h3>
          <p>
            Pay within 60 days to avoid penalties.
          </p>
        </div>

        <div className="feature-box">
          <h3>Pay Online Easily</h3>
          <p>
            Pay challans securely online from anywhere.
          </p>
        </div>

        <div className="feature-box">
          <h3>Status Updated</h3>
          <p>
            Once paid, challan status updates automatically.
          </p>
        </div>

      </div>

    </div>

  </div>

</section>

{/* PAYMENT DEMO SECTION */}

<section className="pay-section">

  <div className="container">

    <div className="section-title">

      <h2>
        How to Check & Pay <span>E-Challan?</span>
      </h2>

      <p>
        Watch the demo to see how easy it is to check and pay your traffic
        challans on our platform
      </p>

    </div>

    <div className="payment-phone">

      {/* PHONE FRAME */}

      <div className="phone-frame">

        <div className="phone-notch"></div>

        <div className="phone-screen">

          {/* TOP LOGO */}

          <div className="demo-top">

            <img
              src="https://www.challanwala.com/assets/images/logo.png"
              alt=""
            />

            <div className="demo-user"></div>

          </div>

          {/* SUCCESS ICON */}

          <div className="success-circle">
            ✓
          </div>

          <h3>
            Payment Successful!
          </h3>

          <p className="success-text">
            Your challans have been cleared
          </p>

          {/* PAYMENT BOX */}

          <div className="payment-card">

            <div className="payment-row">
              <span>Vehicle</span>
              <strong>MH12AB1234</strong>
            </div>

            <div className="payment-row">
              <span>Challans Paid</span>
              <strong>2</strong>
            </div>

            <div className="payment-row">
              <span>Total Paid</span>
              <strong className="green">
                ₹3,500
              </strong>
            </div>

          </div>

          {/* BUTTON */}

          <button className="replay-btn">
            ↻ Replay Demo
          </button>

        </div>

      </div>

    </div>

  </div>

</section>

{/* FAQ SECTION */}

<section className="faq-section">

  <div className="container">

    <div className="section-title">

      <h2>
        Frequently Asked <span>Questions</span>
      </h2>

      <p>
        Find answers to common questions related to E-Challan,
        payment process, penalties, and traffic violations.
      </p>

    </div>

    <div className="faq-wrapper">

      {/* FAQ 1 */}

      <details className="faq-item">

        <summary>
          What is an E-Challan?
          <span>+</span>
        </summary>

        <p>
          An E-Challan is a digitally generated traffic fine issued
          by traffic police for violating road safety rules.
        </p>

      </details>

      {/* FAQ 2 */}

      <details className="faq-item">

        <summary>
          How can I check my pending challan?
          <span>+</span>
        </summary>

        <p>
          You can enter your vehicle number on the portal to instantly
          view all pending traffic challans linked to your vehicle.
        </p>

      </details>

      {/* FAQ 3 */}

      <details className="faq-item">

        <summary>
          Can I pay my challan online?
          <span>+</span>
        </summary>

        <p>
          Yes, you can securely pay your E-Challan online using
          UPI, debit card, credit card, or net banking.
        </p>

      </details>

      {/* FAQ 4 */}

      <details className="faq-item">

        <summary>
          What happens if I don't pay the challan?
          <span>+</span>
        </summary>

        <p>
          Unpaid challans may lead to extra penalties, legal action,
          or suspension of vehicle-related services.
        </p>

      </details>

      {/* FAQ 5 */}

      <details className="faq-item">

        <summary>
          How long does it take for payment status to update?
          <span>+</span>
        </summary>

        <p>
          In most cases, payment status gets updated instantly
          after successful transaction completion.
        </p>

      </details>

      {/* FAQ 6 */}

      <details className="faq-item">

        <summary>
          Can I download the payment receipt?
          <span>+</span>
        </summary>

        <p>
          Yes, after successful payment you can easily download
          and save your challan payment receipt.
        </p>

      </details>

    </div>

  </div>

</section>

{/* NEWSLETTER SECTION */}

<section className="newsletter-section">

  <div className="container">

    <div className="newsletter-box">

      {/* LEFT */}

      <div className="newsletter-left">

        <h2>
          Stay Updated with ChallanWala
        </h2>

        <p>
          Get the latest updates on vehicle regulations,
          traffic rules, and exclusive offers directly in your inbox.
        </p>

      </div>

      {/* RIGHT */}

      <div className="newsletter-right">

        <div className="newsletter-form">

          <input
            type="email"
            placeholder="Enter your email address"
          />

          <button>
            Subscribe
            <span>→</span>
          </button>

        </div>

        <small>
          By subscribing, you agree to our Privacy Policy and Terms of Service.
        </small>

      </div>

    </div>

  </div>

</section>

    </div>

  );
}

export default ChallanPage;